import { MarkerDataType, MarkerTypeEnum } from '@app/models/map-marker.model';
import { ReservationTypeEnum } from '@app/models/reservation-type.model';

// Based on mocked data and the current contract (PL-2179)
// May require adjustments during future development.
export const convertGeoJsonToMarkers = (geoJson: GeoJSON.FeatureCollection): MarkerDataType[] => {
    return geoJson.features
        .filter(
            (feature): feature is GeoJSON.Feature<GeoJSON.Point> =>
                feature.geometry?.type === 'Point',
        )
        .map((feature, index) => {
            const coords = (feature.geometry as GeoJSON.Point).coordinates;
            const position = {
                lng: coords[0],
                lat: coords[1],
            };

            const rawType = feature.properties?.type;
            const id = feature.properties?.id?.toString() ?? `${index}`;

            let type: MarkerTypeEnum = MarkerTypeEnum.Accommodation;
            let rate: number | undefined;
            let baseRate: number | undefined;
            let currency: string | undefined;
            let reservationType: ReservationTypeEnum | undefined;
            let cheapestRateCheckIn: string | undefined;
            let cheapestRateCheckOut: string | undefined;
            let isUnavailable: boolean | undefined;
            let isInitiallySelected: boolean | undefined;            

            const cheapestRate = feature.properties?.cheapestRate;

            if (rawType === MarkerTypeEnum.Accommodation) {
                type = MarkerTypeEnum.Accommodation;
                rate = cheapestRate?.convertedRate ?? cheapestRate?.rate;
                baseRate = cheapestRate?.convertedBaseRate ?? cheapestRate?.baseRate;
                currency = cheapestRate?.convertedCurrency ?? cheapestRate?.currency;
                reservationType = feature.properties?.reservationType;
                cheapestRateCheckIn = cheapestRate?.checkIn;
                cheapestRateCheckOut = cheapestRate?.checkOut;
                isUnavailable = feature.properties?.isUnavailable;
                isInitiallySelected = feature.properties?.isInitiallySelected;
            }

            return {
                id,
                position,
                type,
                rate,
                baseRate,
                currency,
                reservationType,
                cheapestRateCheckIn,
                cheapestRateCheckOut,
                isUnavailable,
                isInitiallySelected,                
            };
        });
};
